module.exports = __webpack_public_path__ + "img/phone.e3cd27b5.svg";